import {
  Dropdown,
  FormField,
  listItemSelectBuilder
} from "@wix/design-system";
import React, { useMemo } from "react";
import { useBiNext } from "./../../bi-context-provider/bi-context-provider.js";
import { isDefined } from "./../../../wix-rich-content-common/index.js";
import { LINK_MODAL_ID } from "../constants.js";
import { LINK_TYPE } from "../data-hooks/data-hooks.js";
const translationTypes = {
  blogPost: "BlogPost",
  section: "Section",
  staticPage: "StaticPage",
  dynamicPage: "DynamicPage",
  "web-address": "WebAddress"
};
const configToOption = (t, linkType) => listItemSelectBuilder({
  id: linkType,
  label: t(`LinkSettings_TypeSelect_Option_${translationTypes[linkType]}`),
  size: "small",
  title: t(`LinkSettings_TypeSelect_Option_${translationTypes[linkType]}`)
});
const defaultOptions = ["web-address", "section"];
const TypeSelect = ({
  autoFocus,
  dropDownPopoverProps,
  onSelect,
  showSitePages,
  t,
  type,
  enabledLinkTypes,
  cache
}) => {
  const logBi = useBiNext({ pluginId: "link", modalId: LINK_MODAL_ID });
  const options = useMemo(() => {
    const availableLinkTypes = [
      ...defaultOptions,
      cache?.staticPage?.type === "ready" && cache?.staticPage?.items?.length > 0 ? "staticPage" : void 0,
      cache?.blogPost?.type === "ready" && cache?.blogPost?.items?.length > 0 ? "blogPost" : void 0,
      cache?.dynamicPage?.type === "ready" && cache?.dynamicPage?.items?.length > 0 ? "dynamicPage" : void 0
    ].filter(isDefined).filter((linkType) => enabledLinkTypes?.length ? enabledLinkTypes.includes(linkType) : true);
    return availableLinkTypes.map((linkType) => configToOption(t, linkType));
  }, [
    showSitePages,
    t,
    enabledLinkTypes,
    cache?.staticPage?.type,
    cache?.blogPost?.type,
    cache?.dynamicPage?.type
  ]);
  const onOptionsShow = () => {
    logBi({ dataHook: LINK_TYPE });
  };
  const onSelectOption = (option) => {
    onSelect(option.id);
    logBi({ dataHook: LINK_TYPE, value: option.id });
  };
  return /* @__PURE__ */ React.createElement(FormField, { label: t("LinkSettings_TypeSelect_Label"), labelPlacement: "top" }, /* @__PURE__ */ React.createElement(
    Dropdown,
    {
      autoFocus,
      dataHook: LINK_TYPE,
      onOptionsShow,
      onSelect: onSelectOption,
      options,
      popoverProps: dropDownPopoverProps,
      selectedId: type,
      size: "small",
      valueParser: (option) => option.label,
      hasMore: true,
      infiniteScroll: [cache?.staticPage, cache?.blogPost, cache?.dynamicPage].some(
        (state) => state && state.type === "loading"
      )
    }
  ));
};
export {
  TypeSelect
};
//# sourceMappingURL=type-select.js.map
